import { render, staticRenderFns } from "./AppCardPhoto.vue?vue&type=template&id=155e730e&scoped=true&"
import script from "./AppCardPhoto.vue?vue&type=script&lang=ts&"
export * from "./AppCardPhoto.vue?vue&type=script&lang=ts&"
import style0 from "./AppCardPhoto.vue?vue&type=style&index=0&id=155e730e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155e730e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})
